import parse from "../parse";
import { CourseTemplatesClass } from "../../constants/classes";

export default async function getCourseTemplateById(id) {
  const courseTemplate = parse.Object.extend(CourseTemplatesClass);
  const query = new parse.Query(courseTemplate);
  query.equalTo("objectId", id);
  return await query.find();
}
